import CardCommon from '@op/components/CardCommon';
import { CONTACT_EMAIL } from '@op/constants';
import React, { useMemo, useState } from 'react';
import { getLocale, useIntl } from 'umi';
import { SteamPlatformTitle } from '../components/SteamGameStore';
import { Col, Row } from 'tea-component';
import { formatFilterDate } from '@op/utils/time';
import AllReviewsChart from '../components/AllReviewsChart';
import SingleLanguageChart from '../components/SingleLanguageChart';
import { useSteamSupportLanguage } from '../hooks';
import '../scss/steamSupportLanguage.scss';
import { LocaleType } from '@op/types/common';
interface ISteamSupportLanguage {
  filter: any;
  gameInfo: any;
}
const SteamSupportLanguage = (props: ISteamSupportLanguage) => {
  const { filter } = props;
  const lang: LocaleType = getLocale();
  const { formatMessage } = useIntl();
  const [sortBy, setSortBy] = useState('all_reviews');
  const isHourly = filter?.date_type === 'hourly';
  const isHourProps = useMemo(() => {
    if (!isHourly) {
      return {};
    }
    return {
      emptyTitleText: formatMessage({
        id: 'Hourly data unavailable in this section.',
      }),
      emptyDescText: formatMessage({
        id: 'Contact {email} for assistance',
      }, { email: CONTACT_EMAIL }),
    };
  }, [isHourly, formatMessage]);

  const {
    loading,
    data,
    translateLanguage,
    selectedLanguage,
    setSelectedLanguage,
    languageData,
    metric,
    setMetric,
    timeline,
  } = useSteamSupportLanguage({
    filter,
    extraData: {
      sortBy,
    },
  });

  function translate(key: string) {
    return translateLanguage?.[key]?.[lang] || key;
  }

  const { languageSelectOptions, isEmpty } = useMemo(() => {
    const languageList = new Set<string>();
    data?.table?.forEach((val: { language: string }) => {
      languageList.add(val.language);
    });

    const options = Array.from(languageList)?.map((val: string) => ({
      text: translate(val),
      value: val,
      handleClick: () => setSelectedLanguage(val),
    }));

    return {
      languageSelectOptions: options,
      isEmpty: options.length === 0,
    };
  }, [data, formatMessage]);

  return (
    <CardCommon
      className="dbo-steam-support-language"
      title={
        <SteamPlatformTitle
          title={'All Reviews of Supported Language'}
          channelName="steam"
          // titleTips={steamPerformanceSupportLanguageTips}
          size={16}
          time={formatMessage(
            {
              id: `From the game's release on Steam to {time}, language statistics are directly derived from the Steam page`,
            },
            {
              time: formatFilterDate(languageData?.time, {
                date_type: 'daily',
              }),
            },
          )}
        ></SteamPlatformTitle>
      }
      loading={loading}
      loadingHeight={368}
      empty={isEmpty && timeline.isEmpty}
    >
      <Row>
        <Col>
          <AllReviewsChart
            filter={filter}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            data={data}
            timeline={timeline}
            metric={metric}
            setMetric={setMetric}
            translate={translate}
            sortBy={sortBy}
            setSortBy={setSortBy}
            isEmpty={isEmpty}
          />
        </Col>
        <Col>
          <SingleLanguageChart
            filter={filter}
            languageSelectOptions={languageSelectOptions}
            data={languageData}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            isHourProps={isHourProps}
          />
        </Col>
      </Row>
    </CardCommon>
  );
};

export default SteamSupportLanguage;
